export default __webpack_public_path__ + "static/media/total-members-icon.0a193623.svg";